import { createContext, useContext, type ReactNode } from 'react';

import type { HostState } from './types';
import { useHostBridge } from './useHostBridge';

const HostContext = createContext<HostState | null>(null);

export function HostProvider({ children }: { children: ReactNode }) {
  const state = useHostBridge();
  return <HostContext.Provider value={state}>{children}</HostContext.Provider>;
}

export function useHost(): HostState {
  const ctx = useContext(HostContext);
  if (!ctx) {
    throw new Error('useHost() called outside <HostProvider>');
  }
  return ctx;
}
